import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@progress/kendo-react-dialogs';
import I18n, { translate } from '@utils/i18n';
import api from '@utils/axios';
import { workOrdersMarkAsPublishedPath } from 'routes';
import toast from 'react-hot-toast';

const namespace = 'features.work_orders.index.publish_to_customer_portal';

function PublishToCustomerPortal({ workOrderIds, workOrdersCount, disabled, queryParams }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const usedParams = new URLSearchParams(queryParams);
  const toggleDialog = () => {
    setVisible(!visible);
  };

  const onSubmit = useCallback(() => {
    if (workOrderIds) {
      usedParams.append('ids', workOrderIds);
    } else {
      usedParams.append('all', 'true');
    }

    setLoading(true);
    api
      .get(`${workOrdersMarkAsPublishedPath({ format: 'json' })}?${usedParams}`)
      .then(({ data }) => toast.success(data.message))
      .catch(({ response }) => toast.error(response.data.message))
      .finally(() => {
        setLoading(false);
        setVisible(false);
      });
  }, [workOrderIds, queryParams]);

  return (
    <>
      <button type="button" tabIndex="0" className="qmb-control" disabled={disabled} onClick={toggleDialog}>
        <i className="fa-light fa-arrow-right-to-bracket" />
        {translate('button', { namespace })}
      </button>
      {visible && (
        <Dialog title={I18n.t('generic.confirm')} className="qmb-dialog" onClose={toggleDialog} closeIcon={!loading}>
          {translate('confirm', { namespace, count: workOrdersCount })}

          <div className="modal__footer pull-right" style={{ justifyContent: 'space-between' }}>
            <div className="mt-3">
              <button type="button" className="qmb-button" onClick={toggleDialog} disabled={loading}>
                {I18n.t('generic.cancel')}
              </button>
              <button type="button" className="qmb-button--submit" onClick={onSubmit} disabled={loading}>
                {I18n.t('generic.ok')}
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
}

PublishToCustomerPortal.propTypes = {
  workOrderIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  workOrdersCount: PropTypes.number.isRequired,
  queryParams: PropTypes.object.isRequired
};

PublishToCustomerPortal.defaultProps = {
  workOrderIds: null
};

export default PublishToCustomerPortal;
